import { isServer } from '@flipster/utils/env-helper';

export function getAppInfo(): AppInfo | undefined {
  if (isServer) return undefined;
  return window.getAppInfo?.();
}

interface AppInfoFeatureFlags {
  disableVerticalScroll?: boolean;
}

interface AppInfo {
  device: 'Android' | 'iOS';
  appVersion: string;
  appBuildNumber: string;
  fromBackground: boolean;
  userId?: string;
  email?: string;
  uid?: string;
  featureFlags?: AppInfoFeatureFlags;
  /**
   * BCP-47 language tag the native app currently uses (e.g. `'en-US'`, `'ja-JP'`).
   * The chart webview lives outside the `[locale]` segment, so this is the only
   * signal available for localizing client-rendered chart UI. May be undefined
   * on older app versions.
   */
  acceptLanguage?: string;
}

declare global {
  interface Window {
    // 앱에서 웹뷰에 심어주는 함수.
    // 차트 화면에서만 주입되고 있음.
    getAppInfo?: () => AppInfo;
  }
}
